import React from 'react';

const FilterLogs = ({ logs, filters, children }) => {
  const filtered =
    filters.length === 0
      ? logs
      : logs.filter((log) => filters.includes(log.event));
  const components = React.Children.map(children, (child) => {
    return React.cloneElement(child, {
      logs: filtered,
    });
  });

  return <React.Fragment>{components}</React.Fragment>;
};

export default FilterLogs;
